import { axios } from '@Root/API'

export const getAllSubmissions = (formId, params = {}) => {
  return axios.get(`cognito-submissions`, { params: { ...params, cognito_form_id: formId } })
}
